<template>
	<AttachmentDownload
        :attachment="rowData.file"
        title="Download"
    />
</template>

<script>
	import AttachmentDownload from '../AttachmentDownload';
	export default {
		name: 'ColumnReport',
		components: {
            AttachmentDownload
		},
		props: {
			rowData: {
				type: Object,
				required: true,
			},
			rowIndex: {
				type: Number,
			},
		},
		//Use computed properties instead of data here, otherwise sorting/pagination will break
	}
</script>
